/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { Team } from './Team.js';
import {
    TeamFromJSON,
    TeamFromJSONTyped,
    TeamToJSON,
} from './Team.js';

/**
 * 
 * @export
 * @interface CreateTeamResponse
 */
export interface CreateTeamResponse {
    /**
     * 
     * @type {Team}
     * @memberof CreateTeamResponse
     */
    data?: Team;
    /**
     * 
     * @type {number}
     * @memberof CreateTeamResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateTeamResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateTeamResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof CreateTeamResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the CreateTeamResponse interface.
 */
export function instanceOfCreateTeamResponse(value: object): boolean {
    return true;
}

export function CreateTeamResponseFromJSON(json: any): CreateTeamResponse {
    return CreateTeamResponseFromJSONTyped(json, false);
}

export function CreateTeamResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTeamResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : TeamFromJSON(json['data']),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function CreateTeamResponseToJSON(value?: CreateTeamResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': TeamToJSON(value['data']),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

